import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { apiService } from '../../api-base'
import { BrandByIdType, BrandRequest, BrandResponse } from './types'

export class BrandsServices {
  static getBrands(
    config: AxiosRequestConfig,
  ): Promise<AxiosResponse<BrandResponse[]>> {
    return apiService.get<AxiosResponse<[]>>('/brands', config)
  }

  static getBrandById(id: string): Promise<AxiosResponse> {
    return apiService.get<AxiosResponse<BrandByIdType>>(`/brands/${id}`)
  }

  static createBrands(data: BrandRequest): Promise<AxiosResponse> {
    return apiService.post<AxiosResponse>('/brands', data)
  }

  static updateBrands = (id: string, data: BrandRequest) => {
    return apiService.put<AxiosResponse<BrandRequest>>(`/brands/${id}`, data)
  }

  static removeBrands(id: string) {
    return apiService.delete(`/brands/${id}`)
  }
}
